// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxLabel_wrapper__3I5jn","label":"CheckboxLabel_label__nTCWM","checkbox":"CheckboxLabel_checkbox__P38FR"};